import React from 'react';
import CommonHeader from '../../Components/CommonHeader/common-header.component';
import Footer from '../../Components/Footer/footer.component';

function CGVPage() {
  return (
    <div>
      <CommonHeader />
      <div style={{
        backgroundColor: '#f7f8f8',
        fontFamily: "Montserrat",
        padding: "40px",
      }}>
        <h1 style={{
          fontSize: "2rem",
          marginBottom: "20px",
          color: "#25A6E4"
        }}>
          Conditions Générales de Vente et d'Utilisation
        </h1>
        <p style={{ textAlign: 'right', marginBottom: '2rem' }}>
          <strong>Date d'entrée en vigueur : 16/05/2025</strong>
        </p>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            1. Objet
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les présentes conditions générales de vente s'appliquent sans restriction ni réserves à l'ensemble des missions de transports proposées par la société à responsabilité limitée TRANSPORT PROFESSIONNEL EXPRESS au capital de 57.000 euros, dont le siège est situé 3 avenue Montesquieu -- 77270 Villeparisis, immatriculée au Registre du Commerce et des Sociétés de Meaux sous le numéro 802 636 985 (ci-après, le « Prestataire » ou « TPE ») sur le site internet <a href="https://b2bglob.com/" style={{ color: '#25A6E4' }}>https://b2bglob.com/</a> (ci-après, le « Site »).
          </p>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            TPE peut être contactée aux coordonnées suivantes :
          </p>
          <ul style={{
            margin: "10px 0 20px",
            paddingLeft: "20px"
          }}>
            <li style={{ listStyleType: 'disc' }}>Adresse postale : 3 avenue Montesquieu -- 77270 Villeparisis</li>
            <li style={{ listStyleType: 'disc' }}>Téléphone : +33 09 82 38 91 94</li>
            <li style={{ listStyleType: 'disc' }}>Email : tpe-transport@hotmail.com</li>
          </ul>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            2. Application des CGV
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les CGV prévalent sur toutes autres conditions générales ou particulières non expressément agréées par TPE.
          </p>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Elles peuvent être complétées le cas échéant par des conditions d'utilisation particulières à certains services et/ou produits offerts sur le Site.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            3. Capacité juridique et acceptation
          </h2>
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            3.1 Capacité juridique
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Le Site est accessible à toute entreprise individuelle ou toute personne morale agissant par l'intermédiaire d'une personne physique disposant de la capacité juridique pour contracter.
          </p>
          
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            3.2 Acceptation des conditions
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            L'acceptation des CGV par l'Acheteur est matérialisée par une case à cocher dans le formulaire de commande sur le Site. Toute acceptation sous réserve est considérée comme nulle.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            4. Inscription sur le Site
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            La passation de commande nécessite une inscription préalable. L'Acheteur garantit que toutes les informations fournies sont exactes, à jour et sincères.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            5. Caractéristiques des Prestations
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Avant de passer commande, l'Acheteur remplit obligatoirement un formulaire permettant de définir son besoin. TPE fera en sorte que les descriptions des Prestations soient les plus fidèles possibles.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            6. Commande
          </h2>
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            6.1 Passation de commande
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Pour passer une commande, l'Acheteur doit remplir le formulaire prévu et fournir l'ensemble des documents obligatoires.
          </p>
          
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            6.2 Confirmation de commande
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            À l'issue de sa commande, l'Acheteur reçoit par email une confirmation récapitulant les éléments de la commande.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            7. Prix et modalités de paiement
          </h2>
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            7.1 Prix
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les prix sont indiqués en euros hors taxes et évoluent en fonction de la nature des Prestations, du poids et volume de la marchandise.
          </p>
          
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            7.2 Modalités de paiement
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Le paiement peut s'effectuer :
          </p>
          <ul style={{
            margin: "10px 0 20px",
            paddingLeft: "20px"
          }}>
            <li style={{ listStyleType: 'disc' }}>Par carte bancaire à la commande</li>
            <li style={{ listStyleType: 'disc' }}>Par prélèvements bancaires chaque mardi</li>
          </ul>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            En cas de retard de paiement, une pénalité contractuelle égale à trois fois le taux légal en vigueur est appliquée.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            8. Droit de rétractation
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les commandes transmises au Prestataire sont en principe irrévocables pour l'Acheteur et ne peuvent faire l'objet d'aucun remboursement.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            9. Réalisation des Prestations
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Le Vendeur demeure libre de déterminer seul les moyens nécessaires à la réalisation de la Prestation. Le Vendeur reconnaît être tenu à une obligation générale de moyens et de conseil.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            10. Obligations des Acheteurs
          </h2>
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            10.1 Avant la réalisation
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            L'Acheteur s'engage à respecter toutes les obligations légales relatives à la Prestation, notamment concernant l'emballage et l'étiquetage.
          </p>
          
          <h3 style={{ fontSize: "1.1rem", margin: "10px 0" }}>
            10.2 Au moment de la réalisation
          </h3>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            L'Acheteur s'oblige à mettre la marchandise à disposition du Vendeur aux date et heure convenues.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            11. Responsabilité de TPE
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            TPE ne saurait être tenue responsable de tout dommage résultant d'une indisponibilité du Site. La responsabilité de TPE ne peut excéder les sommes encaissées au titre de la Prestation concernée.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            12. Confidentialité
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les informations communiquées dans le cadre de l'exécution de la commande sont considérées comme confidentielles.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            13. Assurances
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Le transport des marchandises est assuré à hauteur de 100.000 euros. Pour les marchandises de valeur supérieure, l'Acheteur doit en informer le Vendeur.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            14. Force majeure
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les obligations des parties seront suspendues en cas de force majeure (guerre, grève, épidémie mondiale, catastrophes naturelles, etc.). Cette suspension ne s'applique pas aux obligations de paiement.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            15. Propriété intellectuelle
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Tous les contenus du Site sont protégés par les droits de propriété intellectuelle. Toute reproduction sans autorisation est strictement interdite.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            16. Données personnelles
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les données personnelles sont collectées conformément à notre politique de confidentialité disponible sur le Site.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            17. Comportements prohibés
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Sont strictement interdits : les intrusions dans les systèmes de TPE, les détournements de ressources, et toute utilisation contraire aux CGV.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            18. Modifications
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            TPE se réserve le droit de modifier les présentes CGV à tout moment. Les conditions applicables seront celles en vigueur à la date de la commande.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            19. Désinscription
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            L'Acheteur peut se désinscrire du Site à tout moment par email. La désinscription est effective dans un délai maximum de 7 jours.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            20. Loi applicable et juridiction
          </h2>
          <p style={{
            fontSize: "1rem",
            lineHeight: "1.6"
          }}>
            Les CGV sont régies par la loi française. Tout litige sera porté devant le tribunal de commerce de Meaux.
          </p>
        </article>

        <article>
          <h2 style={{
            fontSize: "1.3rem",
            margin: "20px 0 10px",
            color: '#333'
          }}>
            Annexe : Formulaire de rétractation
          </h2>
          <div style={{ 
            border: '1px solid #ccc', 
            padding: '20px', 
            marginTop: '15px',
            backgroundColor: '#fff'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              fontSize: '1.2rem', 
              marginBottom: '15px',
              color: '#25A6E4'
            }}>
              FORMULAIRE DE RETRACTATION
            </h3>
            <p>
              Je vous notifie par la présente, ma rétractation du contrat portant sur le service ci-après mentionné :
            </p>
            <div style={{ margin: '15px 0' }}>
              <p><strong>Numéro de client :</strong></p>
              <p><strong>Nom de l'Acheteur :</strong></p>
              <p><strong>Adresse de l'Acheteur :</strong></p>
            </div>
            <div style={{ marginTop: '20px' }}>
              <p><strong>Signature de l'Acheteur :</strong></p>
              <p><strong>Date :</strong></p>
            </div>
          </div>
        </article>

        <p style={{
          fontSize: "1rem",
          lineHeight: "1.6",
          marginTop: "30px"
        }}>
          Pour toute question relative à ces conditions générales, veuillez nous contacter à l'adresse <a href="mailto:tpe-transport@hotmail.com" style={{ color: '#25A6E4' }}>tpe-transport@hotmail.com</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default CGVPage;